import React from 'react';
import styles from './FourSensorIcons.scss';
import classNames from 'classnames/bind';
import {
  TemperatureIcon,
  ChemicalsIcon,
  HumidityIcon,
  DustIcon,
  Co2Icon
} from '../../components/index';

const cx = classNames.bind(styles);

const FourSensorIcons = ({
  isGlow = false,
}) => {
  if (isGlow) {
    return (
      <div className={cx('FourSensorIcons')}>
        <Co2Icon/>
        <ChemicalsIcon/>
        <TemperatureIcon/>
        <HumidityIcon/>
      </div>
    );
  } else {
    return (
      <div className={cx('FourSensorIcons')}>
        <DustIcon/>
        <ChemicalsIcon/>
        <TemperatureIcon/>
        <HumidityIcon/>
      </div>
    );
  }
};

export default FourSensorIcons;


// WEBPACK FOOTER //
// ./src/app/intro/components/FourSensorIcons/FourSensorIcons.js